import React from "react";

const TimeMoney = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
    <path className="u_fill"
        d="M19.97 13.55c.47-.19.89-.48 1.25-.83.36-.36.64-.78.83-1.25.19-.47.29-.97.29-1.47s-.1-1-.29-1.47c-.19-.47-.48-.89-.83-1.25-.36-.36-.78-.64-1.25-.83a3.93 3.93 0 00-1.47-.29c-1.02 0-2 .4-2.72 1.12-.71.72-1.12 1.7-1.12 2.72 0 1.02.4 2 1.12 2.72.72.72 1.7 1.12 2.72 1.12.51 0 1-.1 1.47-.29zM18.02 7.6h.96V10h1.92v.96h-2.88V7.6z"
          fill={fill}
    />
    <path className="u_fill"
        d="M29.03 32.12h-1.57v-5.35c0-2-.82-3.95-2.25-5.34L21.68 18l3.52-3.43c.71-.7 1.28-1.53 1.66-2.45.39-.92.59-1.9.59-2.9V3.88h1.57c.25 0 .49-.1.66-.27.18-.18.27-.41.27-.66 0-.25-.1-.49-.27-.66a.874.874 0 00-.65-.29H7.94c-.25 0-.49.1-.67.27a.92.92 0 00-.27.67c0 .25.1.48.27.66.17.18.41.27.66.27H9.5v5.35c0 1 .2 1.98.59 2.9.39.92.95 1.75 1.66 2.45L15.28 18l-3.52 3.43c-.71.7-1.28 1.53-1.66 2.45-.39.92-.59 1.9-.59 2.9v5.35H7.94a.938.938 0 00-.94.93c0 .25.1.49.27.66.17.17.42.28.67.28h21.09c.25 0 .49-.1.66-.27.18-.18.27-.41.27-.66 0-.25-.1-.49-.27-.66a.911.911 0 00-.66-.29zM15.11 13.39A4.8 4.8 0 0113.7 10a4.8 4.8 0 011.41-3.39A4.8 4.8 0 0118.5 5.2a4.8 4.8 0 013.39 1.41c.91.9 1.41 2.12 1.41 3.39a4.8 4.8 0 01-1.41 3.39 4.8 4.8 0 01-3.39 1.41 4.8 4.8 0 01-3.39-1.41zm4.04 7.28c-.18.18-.41.27-.66.27-.25 0-.49-.1-.66-.27a.914.914 0 01-.27-.66c0-.25.1-.49.27-.66.18-.18.41-.27.66-.27.25 0 .49.1.66.27.18.18.27.41.27.66 0 .25-.1.48-.27.66zm.27 2.85c0 .25-.1.49-.27.66-.18.18-.41.27-.66.27-.25 0-.49-.1-.66-.27a.938.938 0 010-1.32c.18-.18.41-.27.66-.27.25 0 .49.1.66.27.17.17.27.41.27.66zm6.02 8.6H11.52v-.07c0-1.6.89-3.03 2.31-3.74l4.23-2.12c.13-.06.27-.1.42-.1.15 0 .29.03.42.1l4.23 2.12a4.157 4.157 0 012.31 3.74v.07z"
        fill={fill}
    />
    </svg>
);

export default TimeMoney;
